import * as Sentry from '@sentry/react';

Sentry.init({
  dsn: 'https://565769b7936d6518ca8a3a93f979f3e5@o1193549.ingest.us.sentry.io/4509984763609089',
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  tracesSampleRate: 1.0,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  environment: process.env.REACT_APP_ENV || 'development',
});

export { Sentry };
